(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-visual-search]');
  if (!btn) return;

  const form = btn.closest('form');
  const fileInput = form?.querySelector('.msb-file');
  if (fileInput) fileInput.click();
});

document.addEventListener('change', async (e) => {
  const input = e.target.closest('.msb-file');
  if (!input) return;

  const file = input.files && input.files[0];
  if (!file) return;

  const endpoint = window.VISUAL_SEARCH_ENDPOINT || null;

  if (!endpoint) {
    alert('Búsqueda por imagen: falta conectar un servicio/app (endpoint).');
    input.value = '';
    return;
  }

  try {
    const fd = new FormData();
    fd.append('image', file);

    const res = await fetch(endpoint, { method: 'POST', body: fd });
    const data = await res.json();

    if (data && data.redirect_url) {
      window.location.href = data.redirect_url;
    } else {
      alert('No se recibieron coincidencias (endpoint sin redirect_url).');
    }
  } catch (err) {
    console.error(err);
    alert('Error procesando la imagen.');
  } finally {
    input.value = '';
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
